// extracted by mini-css-extract-plugin
export default {"tableContainer":"Flights_tableContainer__7kwP5","tableContainer_title":"Flights_tableContainer_title__TpYiN","flights":"Flights_flights__oUDdz"};